export default __webpack_public_path__ + "static/header-escola-2-746ec63a8dbb39568081752fe4f41435.png";